<h1 mat-dialog-title>Kundendaten erfassen</h1>
<div mat-dialog-content>
    <mat-button-toggle-group (change)="salutationChange($event)" style="margin: .5rem 0;">
        <mat-button-toggle value="Herr">Herr</mat-button-toggle>
        <mat-button-toggle value="Frau">Frau</mat-button-toggle>
    </mat-button-toggle-group>
    <mat-form-field appearance="fill">
        <mat-label>Name</mat-label>
        <input matInput [(ngModel)]="data.lastname">
    </mat-form-field>
    <mat-form-field appearance="fill">
        <mat-label>Vorname</mat-label>
        <input matInput [(ngModel)]="data.firstname">
    </mat-form-field>
    <mat-form-field appearance="fill">
        <mat-label>Telefon</mat-label>
        <input matInput [(ngModel)]="data.tel">
    </mat-form-field>
</div>
<mat-divider></mat-divider>
<div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">Abrechen</button>
    <button mat-button color="primary" [mat-dialog-close]="data" cdkFocusInitial>Senden</button>
</div>